var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilBroken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 300,
    viewBox: "0 0 360 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.334 256.012L282.045 230.939L373.565 264.566L207.198 298.193L197.334 256.012Z",
    fill: "#8692AC",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 234.542L151.239 228.061L239.573 229.661L100.378 259.232L54 234.542Z",
    fill: "#8692AC",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 210.379C59 210.379 71.2284 244.129 85.6769 252.186C119.162 270.857 146.984 284.708 169.14 293.737C216.716 313.124 248.048 264.693 248.048 264.693C248.048 264.693 329.194 277.827 370.578 264.693C383.228 260.677 423.536 241.705 423.536 241.705L234.377 159C234.377 159 210.785 194.655 184.389 203.623C173.201 207.424 138.251 219.317 96.5382 219.317C77.5708 219.317 59 210.379 59 210.379Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.324 265.073C177.551 262.911 211.071 262.658 190.569 253.545C170.067 244.433 203.815 242.018 203.815 242.018",
    stroke: "#8D92A5",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-14 49.4037C-14 48.3016 -13.1084 47.4072 -12.0063 47.4037L77.517 47.1206V146.882C77.517 147.987 78.4124 148.882 79.517 148.882H237.097H364.465C364.465 148.882 273.51 187.982 144.997 193.938C16.4846 199.893 16.6441 184.574 16.6441 184.574L-13.1611 163.322C-13.6875 162.946 -14 162.34 -14 161.693V49.4037Z",
    fill: "url(#paint0_linear_1330_46518)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-40.8203 13.7914C-40.8203 13.7914 -8.54967 17.2392 24.7493 17.2392C58.0484 17.2392 91.3474 13.7914 91.3474 13.7914L77.9584 150.034C77.9584 150.034 59.4617 166.124 25.5115 166.124C-8.43865 166.124 -27.4314 150.034 -27.4314 150.034L-40.8203 13.7914Z",
    fill: "url(#paint1_linear_1330_46518)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.17382,
    cy: 16.09,
    rx: 82.1738,
    ry: 16.09,
    fill: "url(#paint2_linear_1330_46518)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.541 245.769H432.303L356.286 226.661L212.285 237.06L202.541 245.769Z",
    fill: "url(#paint3_linear_1330_46518)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 3,
    rx: 11,
    ry: 3,
    transform: "matrix(-1 0 0 1 192 241)",
    fill: "url(#paint4_linear_1330_46518)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.323 223.955C164.734 223.356 163.168 224.885 163.73 226.488L169.558 243.124L171.68 244.825L174.612 243.978L176.868 239.912L179.918 238.539L181.161 235.847L183.927 235.173L184.403 232.777L182.054 229.889L166.323 223.955Z",
    fill: "url(#paint5_linear_1330_46518)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.192 245.707L241.737 232.469L249.574 223.765L208.18 186.494L200.343 195.197L191.333 235.807L193.756 231.904L192.964 236.708L198.151 233.258L196.034 239.56L200.161 238.562L200.161 243.679L204.872 242.13L202.192 245.707Z",
    fill: "url(#paint6_linear_1330_46518)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.988 103.411L324.382 140.682L241.737 232.469C241.737 232.469 242.113 224.25 238.447 221.096C234.781 217.941 227.239 219.414 227.239 219.414C227.239 219.414 226.104 214.184 223.055 211.302C220.007 208.42 214.658 208.087 214.658 208.087C214.658 208.087 215.303 198.891 211.922 195.846C208.541 192.802 200.343 195.197 200.343 195.197L282.988 103.411Z",
    fill: "url(#paint7_linear_1330_46518)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.988 103.411L297.386 116.375L214.741 208.161C214.741 208.161 212.921 202.177 209.448 199.051C205.976 195.924 200.343 195.197 200.343 195.197L282.988 103.411Z",
    fill: "url(#paint8_linear_1330_46518)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286.891 99.0766C294.282 90.8681 306.928 90.2053 315.136 97.5964L326.804 108.102C335.013 115.493 335.676 128.139 328.285 136.348L323.302 141.882L281.908 104.611L286.891 99.0766Z",
    fill: "url(#paint9_linear_1330_46518)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1330_46518",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 281,
    y: 92,
    width: 53,
    height: 50
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M286.891 99.0766C294.282 90.8681 306.928 90.2053 315.136 97.5964L326.804 108.102C335.013 115.493 335.676 128.139 328.285 136.348L323.302 141.882L281.908 104.611L286.891 99.0766Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1330_46518)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 330.373,
    y: 104.587,
    width: 19.3743,
    height: 37.9413,
    transform: "rotate(42 330.373 104.587)",
    fill: "#FFC2E1",
    fillOpacity: 0.262681
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.984 127.718L324.382 140.682L241.737 232.469C241.737 232.469 240.433 226.949 236.789 223.668C233.144 220.387 227.339 219.505 227.339 219.505L309.984 127.718Z",
    fill: "url(#paint10_linear_1330_46518)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.457 76.4504L304.581 65.47C304.594 64.3189 303.678 63.3848 302.535 63.3836C301.392 63.3824 300.455 64.3146 300.442 65.4658L300.318 76.4461C300.305 77.5973 301.221 78.5314 302.364 78.5326C303.507 78.5337 304.444 77.6015 304.457 76.4504Z",
    fill: "url(#paint11_linear_1330_46518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.056 79.0807L285.704 68.9992C285.247 67.9423 284.03 67.4616 282.986 67.9254C281.941 68.3892 281.464 69.6221 281.92 70.679L286.273 80.7605C286.73 81.8174 287.946 82.2981 288.991 81.8343C290.036 81.3704 290.513 80.1376 290.056 79.0807Z",
    fill: "url(#paint12_linear_1330_46518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.738 80.7806L322.335 71.3334C322.922 70.343 322.596 69.076 321.606 68.5035C320.617 67.9309 319.339 68.2697 318.753 69.2601L313.155 78.7073C312.568 79.6977 312.894 80.9647 313.884 81.5373C314.873 82.1098 316.151 81.771 316.738 80.7806Z",
    fill: "url(#paint13_linear_1330_46518)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1330_46518",
    x1: 171.545,
    y1: 191.681,
    x2: 168.436,
    y2: 116.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABBC9",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E284B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1330_46518",
    x1: 13.716,
    y1: 147.22,
    x2: 84.1674,
    y2: 147.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3CED7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1330_46518",
    x1: -210.605,
    y1: -2.92599,
    x2: -211.756,
    y2: 83.5239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAD7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C9EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1330_46518",
    x1: 78.6147,
    y1: 264.298,
    x2: 77.8449,
    y2: 222.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536DB5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E284B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1330_46518",
    x1: 11.5322,
    y1: 9.32273,
    x2: 14.4354,
    y2: -3.55552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536DB5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E284B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1330_46518",
    x1: 158.103,
    y1: 218.279,
    x2: 159.801,
    y2: 240.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#302C48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1330_46518",
    x1: 182.94,
    y1: 229.961,
    x2: 202.609,
    y2: 247.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5CFBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1330_46518",
    x1: 235.869,
    y1: 100.051,
    x2: 255.358,
    y2: 207.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1330_46518",
    x1: 70.8562,
    y1: 294.726,
    x2: 119.608,
    y2: 340.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE39C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1330_46518",
    x1: 282.337,
    y1: 111.789,
    x2: 332.521,
    y2: 131.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1330_46518",
    x1: 97.8523,
    y1: 319.034,
    x2: 146.604,
    y2: 364.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE39C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1330_46518",
    x1: 301.67,
    y1: 62.653,
    x2: 295.128,
    y2: 74.9561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1330_46518",
    x1: 281.898,
    y1: 67.6097,
    x2: 280.926,
    y2: 81.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1330_46518",
    x1: 321.223,
    y1: 67.4382,
    x2: 309.406,
    y2: 74.8222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBroken);
export default __webpack_public_path__ + "static/media/pencil_broken.c05d038e22bdfd2555027407d390be3b.svg";
export { ForwardRef as ReactComponent };